export default __webpack_public_path__ + "static/media/devotionalprayer.cbf069ab.png";